import { useEffect } from 'react';

export function useScreenProtection() {
  useEffect(() => {
    // Block PrintScreen and common screenshot shortcuts
    const handleKeyDown = (e) => {
      // PrintScreen
      if (e.key === 'PrintScreen') {
        e.preventDefault();
        navigator.clipboard?.writeText?.('').catch(() => {});
        return false;
      }

      // Ctrl/Cmd + P (print)
      if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault();
        return false;
      }

      // Ctrl/Cmd + S (save page)
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault();
        return false;
      }

      // Ctrl/Cmd + Shift + S (screenshot tools)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'S') {
        e.preventDefault();
        return false;
      }

      // Windows + Shift + S (Snipping Tool)
      if (e.shiftKey && e.key === 'S' && e.metaKey) {
        e.preventDefault();
        return false;
      }

      // Ctrl + Shift + I (DevTools)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
        e.preventDefault();
        return false;
      }

      // F12 (DevTools)
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }

      // Ctrl + U (View Source)
      if ((e.ctrlKey || e.metaKey) && e.key === 'u') {
        e.preventDefault();
        return false;
      }
    };

    // Block right-click on images/videos/canvas
    const handleContextMenu = (e) => {
      const target = e.target;
      const tag = target.tagName?.toLowerCase();
      if (tag === 'img' || tag === 'video' || tag === 'canvas') {
        e.preventDefault();
        return false;
      }
      // Also block on elements with the protected class
      if (target.closest('.screen-protected')) {
        e.preventDefault();
        return false;
      }
    };

    // Prevent drag on images
    const handleDragStart = (e) => {
      const tag = e.target.tagName?.toLowerCase();
      if (tag === 'img' || tag === 'video') {
        e.preventDefault();
        return false;
      }
    };

    // Detect screen capture / screen sharing via permissions API
    const detectScreenCapture = async () => {
      try {
        if (navigator.permissions) {
          const status = await navigator.permissions.query({ name: 'display-capture' });
          status.onchange = () => {
            if (status.state === 'granted') {
              document.body.classList.add('capture-detected');
            } else {
              document.body.classList.remove('capture-detected');
            }
          };
        }
      } catch {
        // Permission API not supported for display-capture in this browser
      }
    };

    // Clear clipboard on visibility change (some screenshot tools)
    const handleVisibilityChange = () => {
      if (document.hidden) {
        try {
          navigator.clipboard?.writeText?.('').catch(() => {});
        } catch {
          // Clipboard API not available
        }
      }
    };

    // Block copy on protected content
    const handleCopy = (e) => {
      const selection = window.getSelection();
      const container = selection?.anchorNode?.parentElement;
      if (container?.closest?.('.screen-protected')) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('keydown', handleKeyDown, { capture: true });
    document.addEventListener('keyup', (e) => {
      if (e.key === 'PrintScreen') {
        navigator.clipboard?.writeText?.('').catch(() => {});
      }
    }, { capture: true });
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('copy', handleCopy);
    detectScreenCapture();

    return () => {
      document.removeEventListener('keydown', handleKeyDown, { capture: true });
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('copy', handleCopy);
    };
  }, []);
}
